import { appMessageSources } from "../enums";
import { highlightKeyword } from "utils/helper";
import "./MessageContent.scss";

const { IN_APP } = appMessageSources;

const MessageContent = ({
    isReceivedMessage,
    messageContent,
    messageSource,
    keywordSearch,
    messageId,
}) => {
    const receipientClass = isReceivedMessage ? "received" : "sent";
    const messageSourceClass =
        messageSource === IN_APP && isReceivedMessage ? "" : "other";

    // Highlight keywords if keywordSearch is provided
    const highlightedContent = keywordSearch
        ? highlightKeyword(messageContent, keywordSearch, messageId)
        : messageContent;

    return (
        <>
            {messageContent !== "" && (
                <div
                    className={`message__content ${receipientClass} ${messageSourceClass}`}
                    dangerouslySetInnerHTML={{ __html: highlightedContent }}>
                </div>
            )}
        </>
    );
};

export default MessageContent;
